<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>学生管理</el-breadcrumb-item>
    <el-breadcrumb-item>学生预约查看</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>
  <el-table
      ref="ieltsList"
      :data="apponinList"
      border
      show-overflow-tooltip="true"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column
        prop="appointmentDate"
        :show-overflow-tooltip="true"
        label="预约时间"
        width="180">
      </el-table-column>
       <el-table-column
        prop="adress"
        :show-overflow-tooltip="true"
        label="预约地点"
        width="180">
      </el-table-column>
      <el-table-column
      prop="content"
      :show-overflow-tooltip="true"
      label="预约内容"
      width="180">
    </el-table-column>
      <el-table-column
        prop="teacherGroupName"
        :show-overflow-tooltip="true"
        label="预约老师"
        width="180">
      </el-table-column>
      <el-table-column
        prop="name"
        :show-overflow-tooltip="true"
        label="预约学生"
        width="180">
      </el-table-column>
       <el-table-column
        label="是否预约"
        width="100"
       >
       <template slot-scope="scope">
         <el-button  type="success" @click="subAppointment(scope.row)">预约</el-button>
       </template>
      </el-table-column>
    
    </el-table>
  </el-card>
    </div>
  </template>
  
  <script>
  export default {
    created(){
     this.getAppoinment()
    },
  data(){
      return{
        pickerOptions: {
            disabledDate(time) {
            return time.getTime() > Date.now();
          } },
          apponinList:[],
      }
  },
  methods:{
    getAppoinment(){
    this.axios.post("/apponintment/selectTeacherApponintment?teacherId="+JSON.parse(localStorage.getItem("user")).userid+"&adress=c")
        .then((resp) => {
          if (resp.data.status == 1) {
           console.log(resp.data.result)
           this.apponinList=resp.data.result
          } else {
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
  },subAppointment(data){
    console.log(data)
    this.axios.post("/apponintment/updateApponintment?teacherId="+JSON.parse(localStorage.getItem("user")).userid+"&appointmentId="+data.appointmentId)
        .then((resp) => {
          if (resp.data.status == 1) {
            this.getAppoinment()
            this.$message.success("预约成功")
           console.log(resp.data.result)
          } else {
            console.log(resp.data)
            this.$message.error(resp.data.message)
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
  },
    stateFormat(row, column) {
      if (row.isSuccess === null) {
        return '暂未预约'
      } else if(row.checkWork==1){
        return '预约成功'
      }else  {
        return '已查看'
      }} ,
  },
  
  }
  </script>
  
  <style>
  
  </style>


// WEBPACK FOOTER //
// src/components/work/teacher/VieApponintment.vue